import { ComponentFactoryResolver, ComponentRef, Directive, Input, OnChanges, OnInit, Type, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClearanceItemAssetBaseComponent } from './clearance-item-asset-base.component';
import { ClearanceItemImageComponent } from './clearance-item-image.component';
import { ClearanceItemDocumentComponent } from './clearance-item-document.component';
import { AssetConfig } from './asset-config.interface';
import { IAsset } from './asset.interface';

const components: { [type: string]: Type<ClearanceItemAssetBaseComponent> } = {
  image: ClearanceItemImageComponent,
  document: ClearanceItemDocumentComponent
};

@Directive({
  selector: '[dynamicAsset]'
})
export class AssetDirective implements OnChanges, OnInit {
  @Input()
  config: AssetConfig;
  @Input()
  assetType: string;
  @Input()
  group: FormGroup;
  @Input()
  hideReportDefaultIcons: boolean;
  @Input()
  preventRemoval: boolean;
  @Input()
  current: number

  @Output() removeAsset = new EventEmitter<number>();
  @Output() enlargeAsset = new EventEmitter<FormGroup>();
  @Output() setDefault = new EventEmitter<FormGroup>();
  @Output() showOnReport = new EventEmitter<FormGroup>();
  @Output() download = new EventEmitter<FormGroup>();

  component: ComponentRef<ClearanceItemAssetBaseComponent>;

  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }

  ngOnChanges() {
    if (this.component) {
      this.setValuesOnProperties();
    }
  }

  ngOnInit() {
    if (!components[this.assetType]) {
      const supportedTypes = Object.keys(components).join(', ');
      throw new Error(
        `Trying to use an unsupported type (${this.assetType}). Supported types: ${supportedTypes}`
      );
    }
    const component = this.resolver.resolveComponentFactory<ClearanceItemAssetBaseComponent>(components[this.assetType]);
    this.component = this.container.createComponent(component);
    this.setValuesOnProperties();    
  }

  setValuesOnProperties(){
    this.component.instance.assetItemForm = this.group;
    this.component.instance.enlarge = this.enlargeAsset;
    this.component.instance.showOnReport = this.showOnReport;
    this.component.instance.download = this.download;
    this.component.instance.remove = this.removeAsset;
    this.component.instance.setDefault = this.setDefault;
    this.component.instance.hideReportDefaultIcons = this.hideReportDefaultIcons;
    this.component.instance.current = this.current;
    this.component.instance.preventRemoval = this.preventRemoval;
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/asset-management/clearance-item-asset-directive.ts